var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"},on:{"click":_vm.click}},[_c('use',{attrs:{"xlink:href":_vm.type}})])
}
var staticRenderFns = []

export { render, staticRenderFns }